import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import ErrorBoundary from '../ErrorBoundary'
// import BootstrapAlert from '../element/BootstrapAlert'
import {
  patchDocument,
  PatchType,
  TextRun
} from 'docx'
import moment from 'moment'
import { convertHarfCharacter } from '../../utility'

function getFormattedRate (rate) {
  const formatted = rate
    .replace(/\.00$/, '')
    .replace(/\.0$/, '')
    .replace(/(\.\d+)0$/, '$1')
  return formatted
}

export default function ContractDraftModal (props) {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const [formatFile, setFormatFile] = useState(null)

  useEffect(() => {
    document.querySelectorAll('button.get-contract-draft').forEach((el) => {
      el.addEventListener('click', () => setModalOpen(true))
    })
  }, [])

  function onInputFileChange (e) {
    const files = e.target.files
    setFormatFile(files.length > 0 ? files[0] : null)
  }

  function onSubmitButtonClick () {
    if (!formatFile) return

    const reader = new FileReader()
    reader.onload = function (event) {
      const arrayBufferData = event.target.result
      const nowDate = moment()

      const replaceTableHeader = {
        header_date: moment(props.periodFrom).format('YYYY/MM/DD')
      }
      const replaceTable = {
        year: convertHarfCharacter(nowDate.format('YYYY'), false),
        month: convertHarfCharacter(nowDate.format('M'), false),
        day: convertHarfCharacter(nowDate.format('D'), false),
        company_name: props.companyName,
        character_title: props.characterTitle,
        period_from: convertHarfCharacter(moment(props.periodFrom).format('YYYY年M月D日'), false),
        period_from_h: moment(props.periodFrom).format('YYYY年M月D日'),
        period_to: convertHarfCharacter(moment(props.periodTo).format('YYYY年M月D日'), false),
        period_to_h: moment(props.periodTo).format('YYYY年M月D日'),
        rate: getFormattedRate(props.rate),
        royalty_total: Number(props.royalityTotal).toLocaleString(),
        address: props.billingAddress ? props.billingAddress.address.trim() : ''
      }
      const replaceTableFooter = {
        footer_id: props.id
      }

      const patches = {}
      for (const [key, value] of Object.entries(replaceTableHeader)) {
        patches[key] = {
          type: PatchType.PARAGRAPH,
          children: [new TextRun({ text: value, size: '9pt' })]
        }
      }
      for (const [key, value] of Object.entries(replaceTable)) {
        patches[key] = {
          type: PatchType.PARAGRAPH,
          children: [new TextRun({ text: value, highlight: 'green' })]
        }
      }
      for (const [key, value] of Object.entries(replaceTableFooter)) {
        patches[key] = {
          type: PatchType.PARAGRAPH,
          children: [new TextRun({ text: value })]
        }
      }

      patchDocument(arrayBufferData, {
        outputType: 'nodebuffer',
        patches: patches
      }).then(finaldata => {
        const blob = new Blob([finaldata], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${props.draftName}.docx`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
    }

    reader.readAsArrayBuffer(formatFile)
  }

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={() => setModalOpen(false)}>
      <div className={classes.paper}>
        <div><a href={props.templateLink} target="_blank" rel="noopener noreferrer">Boxリンク</a>から契約書ドラフトのフォーマットファイルをダウンロードし、下の「ファイルの選択」で指定してください。</div>
        <div>フォーマットファイルは、置換したい箇所を以下の文字列に置き換えたMicrosoft Wordファイルです。</div>
        <ul>
          <li>{'{{header_date}}'}: ヘッダー部の契約開始日</li>
          <li>{'{{year}}'}: 現在年</li>
          <li>{'{{month}}'}: 現在月</li>
          <li>{'{{day}}'}: 現在日</li>
          <li>{'{{company_name}}'}: 会社名</li>
          <li>{'{{character_title}}'}: キャラクター名</li>
          <li>{'{{period_from}}'}: 契約開始日（全角）</li>
          <li>{'{{period_from_h}}'}: 契約開始日（半角）</li>
          <li>{'{{period_to}}'}: 契約修了日（全角）</li>
          <li>{'{{period_to_h}}'}: 契約修了日（半角）</li>
          <li>{'{{rate}}'}: 料率</li>
          <li>{'{{royalty_total}}'}: 最低責任使用料</li>
          <li>{'{{address}}'}: 請求書送付先（会社名は含みません）</li>
          <li>{'{{footer_id}}'}: フッター部の申請ID</li>
        </ul>
        <input type="file" name="file1" accept='application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          onChange={(e) => onInputFileChange(e)} />
        <p>{formatFile ? `設定中のフォーマット：${formatFile.name}` : 'フォーマットファイルを指定してください。'}</p>
        <hr />
        <div className="row">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={() => setModalOpen(false)}>キャンセル</button>
          </div>
          <div className="col-6 text-right">
            <button type='button' className='btn btn-danger' onClick={onSubmitButtonClick} disabled={!formatFile}>
              ダウンロード
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ContractDraftModal.propTypes = {
  templateUrl: PropTypes.string,
  id: PropTypes.string,
  companyName: PropTypes.string,
  characterTitle: PropTypes.string,
  periodFrom: PropTypes.string,
  periodTo: PropTypes.string,
  rate: PropTypes.string,
  royalityTotal: PropTypes.string,
  billingAddress: PropTypes.object,
  templateLink: PropTypes.string,
  draftName: PropTypes.string
}

ContractDraftModal.defaultProps = {
  billingAddress: null
}

document.querySelectorAll('#contract-draft-modal').forEach((el) => {
  const dataset = el.dataset // bladeでdata-xxxx形式で指定した値がpropsとして参照できる]
  const props = {}

  for (const key in ContractDraftModal.propTypes) {
    if (key in dataset) {
      if (key === 'billingAddress') {
        props[key] = JSON.parse(dataset[key])
      } else {
        props[key] = dataset[key]
      }
    }
  }

  ReactDOM.render(
    <ErrorBoundary>
      <ContractDraftModal {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).forEach((key) => { // ソースにdata-属性が残らないように削除
    delete el.dataset['data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase())]
  })
})
